export default __webpack_public_path__ + "static/media/Na_June_37-ai.99baaa46.png";